import { object, string } from "yup";

const validationSchema = object({
  emailCached: string().email("Email Id is incorrect"),
  mobileCached: string().length(10, "Mobile must be 10 digits"),
});

export default validationSchema;
